import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const AddApplicationFetcher = (accessToken, params) => {
  return axios.post(`${apiUrlInternal}/applications`, params, addAuthToFetchOpts(accessToken, {})).then(res => res.data);
}

export const useAddApplicationMutation = (fetcher = AddApplicationFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['add-application'],
    (accessToken, params) => fetcher(accessToken, params),
    {onSuccess: () => {
        queryClient.invalidateQueries('add-application');
        queryClient.invalidateQueries(['application-details', null]);
      }}
  )
}
